import { setLocale } from 'yup';

// has to be called before each schema
export const setYupDefaultMessages = () =>
  setLocale({
    mixed: {
      required: {
        key: 'validation.required',
      },
    },
    string: {
      email: {
        key: 'validation.valid',
      },
      max: ({ max }) => ({
        key: 'validation.maxLength',
        values: { max },
      }),
    },
  });
